import { Component, OnInit, Input } from "@angular/core";
import { StaticPagesService } from "src/app/Services/static-pages.service";
declare var google: any;

@Component({
    selector: "embryo-Map",
    templateUrl: "./Map.component.html",
    styleUrls: ["./Map.component.scss"],
})
export class MapComponent implements OnInit {
    @Input() address: any;

    mapOptions: any = {
        lat: "",
        lng: "",
        zoom: 10,
        fillColor: "#DC143C",
        draggable: true,
        editable: true,
        visible: true,
    };

    showMap = false;

    icon: any = {
        url: "./assets/images/flag.svg",
        scaledSize: {
            width: 40,
            height: 60,
        },
    };
    environmentVariables: any;
    lat: any;
    lng: any;
    constructor(private confgServ: StaticPagesService) {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.mapOptions.lat = res?.GOOGLE_MAP_LATITUDE;
            this.mapOptions.lng = res?.GOOGLE_MAP_LONGITUDE;
        });
    }

    ngOnInit() {
        if (this.address) {
            this.getLatitudeLongitude(this.address);
        }
    }

    getLatitudeLongitude(address: any) {
        address = address;
        const NewMapOptions = this.mapOptions;
        // Initialize the Geocoder
        const geocoder = new google.maps.Geocoder();
        if (geocoder) {
            geocoder.geocode(
                {
                    address: address,
                },
                function (results: any, status: any) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        NewMapOptions.lat = results[0].geometry.location.lat();
                        NewMapOptions.lng = results[0].geometry.location.lng();
                    }
                }
            );

            this.mapOptions.lat = NewMapOptions.lat;
            this.mapOptions.lng = NewMapOptions.lng;
            this.showMap = true;
        }
    }
}
